import { Component, Input, OnInit } from '@angular/core';
import { MasterSummaryQuestionModel, SimpleSurveyQuestion, SurveySummaryAnswerFilter } from '../../../../models/survey/survey.model';
import {
  allowShowBarchart,
  allowShowPieChart, generateIncludeVersionLabel,
  showAverageNumericResponse,
  showMostCommonResponse
} from '../../../../shared/helpers/chart-helper';
import { SurveyVersionModelCore } from '../../../../models/summary/summary.model';

@Component({
  selector: 'app-combined-question-table',
  templateUrl: './combined-question-table.component.html',
  styleUrls: ['./combined-question-table.component.less']
})
export class CombinedQuestionTableComponent implements OnInit {

  questionValue: MasterSummaryQuestionModel;

  @Input()
  get question(): MasterSummaryQuestionModel {
    return this.questionValue;
  }

  set question(val) {
    this.questionValue = val;
    this.questionName = this.questionValue.questionName;
    this.questionType = this.questionValue.answerType;
  }

  listSurveyVersionValue: SurveyVersionModelCore[] = [];

  @Input()
  get listSurveyVersion() {
    return this.listSurveyVersionValue;
  }

  set listSurveyVersion(val) {
    this.listSurveyVersionValue = val;
  }

  @Input() listSimpleSurveyQuestion: SimpleSurveyQuestion[] = [];

  showDropdown = false;
  questionName: string;
  questionType: string;

  @Input() listSurveySummaryAnswerFilter: SurveySummaryAnswerFilter[] = [];
  selectedAnswerId: number;

  constructor() {
  }

  ngOnInit() {
  }

  showChart(barChart: boolean) {
    this.question.barChart = barChart;
    this.question.chart = !barChart;
    this.question.averageResponse = false;
    this.question.mostCommonResponse = false;
  }

  showAverageNumeric() {
    this.question.averageResponse = true;
    this.question.mostCommonResponse = false;
    this.question.barChart = false;
    this.question.chart = false;
  }

  showCommonNumeric() {
    this.question.mostCommonResponse = true;
    this.question.barChart = false;
    this.question.chart = false;
    this.question.averageResponse = false;
  }

  allowShowBarChart(type: string): boolean {
    return allowShowBarchart(type);
  }

  allowShowPieChart(type: string): boolean {
    return allowShowPieChart(type);
  }

  showAverageNumericResponse(type: string): boolean {
    return showAverageNumericResponse(type);
  }

  showMostCommonResponse(type: string): boolean {
    return showMostCommonResponse(type);
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.showDropdown = false;
    }
  }

  getAnswerPercentageNumber(answerPercentage: any): any {
    if (answerPercentage !== undefined && answerPercentage !== null) {
        return Number(answerPercentage).toFixed(2);
    }
    return answerPercentage;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/combined-question-table/combined-question-table.component.ts